/** @flow */
import React, { type ElementProps } from "react";
import { CustomInput } from "reactstrap";
import classNames from "classnames";
import "./radio.style.scss";

type RadioProps = ElementProps<typeof CustomInput>;

const Radio = (props: RadioProps) => (
  <CustomInput
    {...props}
    type="radio"
    readOnly={true}
    className={classNames("radio-container", props.className)}
  />
);

Radio.defaultProps = {
  type: "radio",
};

export default Radio;
